




























import RadialProgress from '@/components/RadialProgress.vue';

export default {
  props: {
    actions: {
      type: Array,
      default: () => ([]),
    },
    sidebarVisible: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    select(action: any) {
      // emit event if action and if not disabled
      action.onclick
        && !action.disabled
        && action.onclick();
    },
  },
  components: {
    RadialProgress,
  },
} as IView;
